<app-no-contract></app-no-contract>

<nb-tabset *ngIf="isContractActive" class="bg-white" fullWidth>
    <!-- badge tab-->
    <nb-tab active="{{setActiveBadge}}" tabTitle="{{'pages_titles.badges' | translate}}" class="tab"
        tabIcon="credit-card-outline" nbSpinnerSize="large">
<app-loader *ngIf="loadingSpinner"></app-loader>


        <div class="text-center mt-5 mb-5" *ngIf="emptyBadgeOffers">
            <p class="p-text">{{'no_active_offer' | translate}} !</p>
        </div>

        <div *ngIf="!emptyBadgeOffers && !loadingSpinner">
            <div *ngFor="let badge of badges" class="mb-4 mt-4">
                <div class="row">
                    <div class="col-12">
                        <div class="float-left">
                            <img src="{{badge.photo}}" class="offers-default-image" alt="offers_image" width="50"
                                height="50" />
                            <span class="text-primary h6 m-2">{{badge.title}}</span>
                        </div>
                        <div class="float-right ">
                            <span *ngIf="badge.isSubscribed && badge.isAvailable"
                                class="badge-min text-badge-success-service mr-2">
                                {{'subscribe' | translate}}
                            </span>
                            <span *ngIf="badge.isAvailable" class="badge-min text-badge-current-service">
                                {{'current_offer' | translate}}
                            </span>
                            <span *ngIf="badge.isSubscribed && !badge.isAvailable"
                                class="badge-min text-badge-not-available-service">
                                {{'deprecated' | translate}}
                            </span>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <p class="mb-2 mt-2"><strong class="text-primary">{{'price' | translate}} </strong>: <span
                                class="price">{{badge.price}}</span></p>
                        <p class="small-p-text">
                            {{badge.description}}
                        </p>
                        <div class="w-100  mt-4">
                            <span *ngIf="isContractActive && badge.isSubscribed === false">
                                <button pButton class="w-25 d-block mt-5 ml-auto"
                                    (click)="openDialog( 'active', badge )">
                                    <span *ngIf="!Load">{{'actions.subscribe' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>

                            <span
                                *ngIf="isContractActive && badge.isSubscribed === true && badge.subscription?.isActive === true">
                                <button pButton class="p-button-danger w-25 d-block mt-5 ml-auto"
                                    (click)="openDialog( 'disable', badge )">
                                    <span *ngIf="!Load">{{'actions.unsubscribe' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>

                            <span
                                *ngIf="isContractActive && badge.isSubscribed === true && badge.subscription?.isActive === false">
                                <button pButton class=" w-25 d-block mt-5 ml-auto "
                                    (click)="openDialog( 'reactive', badge )">
                                    <span *ngIf="!Load">{{'actions.reactivate' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </nb-tab>

    <!-- application mobile APK -->
    <nb-tab active="{{setActiveMobile}}" tabTitle="{{'custom_mobile_app' | translate}}" class="tab"
        tabIcon="smartphone-outline" nbSpinnerSize="large">
<app-loader *ngIf="loadingSpinner"></app-loader>

        <div class="text-center mt-5 mb-5" *ngIf="emptyApkOffers">
            <p class="p-text">{{'no_active_offer' | translate}} !</p>
        </div>

        <div class="mt-4" *ngIf="!emptyApkOffers  && !loadingSpinner">
            <div *ngFor="let apk of apk" class="mb-4 mt-4">
                <div class="row">
                    <div class="col-12">
                        <div class="float-left">
                            <img src="{{apk.photo}}" class="offers-default-image" alt="offers_image" width="50"
                                height="50" />
                            <span class="text-primary h6 m-2">{{apk.title}}</span>
                        </div>
                        <div class="float-right ">
                            <span *ngIf="apk.isSubscribed && apk.isAvailable" class="text-badge-success-service mr-2">
                                {{'subscribe' | translate}}
                            </span>
                            <span *ngIf="apk.isAvailable" class="text-badge-current-service">
                                {{'current_offer' | translate}}
                            </span>
                            <span *ngIf="apk.isSubscribed && !apk.isAvailable" class="text-badge-not-available-service">
                                {{'deprecated' | translate}}
                            </span>
                        </div>
                    </div>

                    <div class="col-12 mt-3">
                        <p class="mb-2 mt-2"><strong class="text-primary">{{'price' | translate}} </strong>: <span
                                class="price">{{apk.price}}</span></p>
                        <p class="small-p-text">
                            {{apk.description}}
                        </p>
                        <div class="w-100  mt-4">
                            <span *ngIf="isContractActive && apk.isSubscribed === false">
                                <button pButton class=" w-25 d-block mt-5 ml-auto "
                                    (click)="openDialog( 'active', apk )">
                                    <span *ngIf="!Load">{{'actions.subscribe' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>

                            <span
                                *ngIf="isContractActive && apk.isSubscribed === true && apk.subscription?.isActive === true">
                                <button pButton class="p-button-danger w-25 d-block mt-5 ml-auto"
                                    (click)="openDialog( 'disable', apk )">
                                    <span *ngIf="!Load">{{'actions.unsubscribe' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>

                            <span
                                *ngIf="isContractActive && apk.isSubscribed === true && apk.subscription?.isActive === false">
                                <button pButton class=" w-25 d-block mt-5 ml-auto "
                                    (click)="openDialog( 'reactive', apk )">
                                    <span *ngIf="!Load">{{'actions.reactivate' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </nb-tab>

    <!-- offer xchange -->
    <nb-tab active="{{setActiveXchange}}" tabTitle="{{'pages_titles.generate_xchange' | translate}}" class="tab"
        tabIcon="message-circle-outline">
<app-loader *ngIf="loadingSpinner"></app-loader>

        <div class="text-center mt-5 mb-5" *ngIf="emptyXchangeOffers">
            <p class="p-text">{{'no_active_offer' | translate}} !</p>
        </div>

        <div class="mt-4" *ngIf="!emptyXchangeOffers  && !loadingSpinner">
            <div *ngFor="let xchange of xchange" class="mb-4">
                <div class="row">
                    <div class="col-12">
                        <div class="float-left">
                            <img src="{{xchange.photo}}" class="offers-default-image" alt="offers_image" width="50"
                                height="50" />
                            <span class="text-primary h6 m-2">{{xchange.title}}</span>
                        </div>
                        <div class="float-right ">
                            <span *ngIf="xchange.isSubscribed && xchange.isAvailable"
                                class="text-badge-success-service mr-2">
                                {{'subscribe' | translate}}
                            </span>
                            <span *ngIf="xchange.isAvailable" class="text-badge-current-service">
                                {{'current_offer' | translate}}
                            </span>
                            <span *ngIf="xchange.isSubscribed && !xchange.isAvailable"
                                class="text-badge-not-available-service">
                                {{'deprecated' | translate}}
                            </span>
                        </div>
                    </div>



                    <div class="col-12 mt-3">
                        <p class="mb-2 mt-2"><strong class="text-primary">{{'price' | translate}} </strong>: <span
                                class="price">{{xchange.price}}</span></p>
                        <p class="small-p-text">
                            {{xchange.description}}
                        </p>
                        <div class="w-100  mt-4">
                            <span *ngIf="isContractActive && xchange.isSubscribed === false">
                                <button pButton class=" w-25 d-block mt-5 ml-auto "
                                    (click)="openDialog( 'active', xchange )">
                                    <span *ngIf="!Load">{{'actions.subscribe' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>

                            <span
                                *ngIf="isContractActive && xchange.isSubscribed === true && xchange.subscription?.isActive === true">
                                <button pButton class="p-button-danger w-25 d-block mt-5 ml-auto"
                                    (click)="openDialog( 'disable', xchange )">
                                    <span *ngIf="!Load">{{'actions.unsubscribe' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>

                            <span
                                *ngIf="isContractActive && xchange.isSubscribed === true && xchange.subscription?.isActive === false">
                                <button pButton class=" w-25 d-block mt-5 ml-auto "
                                    (click)="openDialog( 'reactive', xchange )">
                                    <span *ngIf="!Load">{{'actions.reactivate' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nb-tab>

    <!-- offer Support -->
    <nb-tab active="{{setActiveSupport}}" tabTitle="{{'support' | translate}}" class="tab"
        tabIcon="question-mark-circle-outline" nbSpinnerSize="large">
        <app-loader *ngIf="loadingSpinner"></app-loader>
        <div class="text-center mt-5 mb-5" *ngIf="emptySupportOffers">
            <p class="p-text">{{'no_active_offer' | translate}} !</p>
        </div>

        <div class="mt-4" *ngIf="!emptySupportOffers  && !loadingSpinner">
            <div *ngFor="let support of support" class="mb-4">
                <div class="row">
                    <div class="col-12">
                        <div class="float-left">
                            <img src="{{support.photo}}" class="offers-default-image" alt="offers_image" width="50"
                                height="50" />
                            <span class="text-primary h6 m-2">{{support.title}}</span>
                        </div>
                        <div class="float-right ">
                            <span *ngIf="support.isSubscribed && support.isAvailable"
                                class="badge-min text-badge-success-service mr-2">
                                {{'subscribe' | translate}}
                            </span>
                            <span *ngIf="support.isAvailable" class="support-min text-badge-current-service">
                                {{'current_offer' | translate}}
                            </span>
                            <span *ngIf="support.isSubscribed && !support.isAvailable"
                                class="badge-min text-badge-not-available-service">
                                {{'deprecated' | translate}}
                            </span>
                        </div>
                    </div>

                    <div class="col-12 mt-3">
                        <p class="mb-2 mt-2"><strong class="text-primary">{{'price' | translate}} </strong>: <span
                                class="price">{{support.price}}</span></p>
                        <p class="small-p-text">
                            {{support.description}}
                        </p>
                        <div class="w-100  mt-4">
                            <span *ngIf="isContractActive && support.isSubscribed === false">
                                <button pButton class="w-25 d-block mt-5 ml-auto "
                                    (click)="openDialog( 'active', support )">
                                    <span *ngIf="!Load">{{'actions.subscribe' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>

                            <span
                                *ngIf="isContractActive && support.isSubscribed === true && support.subscription?.isActive === true">
                                <button pButton class="p-button-danger w-25 d-block mt-5 ml-auto"
                                    (click)="openDialog( 'disable', support )">
                                    <span *ngIf="!Load">{{'actions.unsubscribe' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>

                            <span
                                *ngIf="isContractActive && support.isSubscribed === true && support.subscription?.isActive === false">
                                <button pButton class=" w-25 d-block mt-5 ml-auto "
                                    (click)="openDialog( 'reactive', support )">
                                    <span *ngIf="!Load">{{'actions.reactivate' | translate}}</span>
                                    <span *ngIf="Load" class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </span>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nb-tab>
</nb-tabset>
<!-- Show detail service Dialog template end -->


<!--  modal active offer -->
<p-dialog position="bottom" header="{{'Confirm_activate_offer' | translate}}" [(visible)]="displayActiveModal"
    [modal]="true" [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    {{'Confirm_activate_offer' | translate}}
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayActiveModal=false;activeOffer()"
            label="{{'actions.purchase' | translate}}" styleClass="p-button-primary"></p-button>
    </ng-template>
</p-dialog>


<!-- modal disable offer -->
<p-dialog position="bottom" header="{{'Confirm_deactivate_offer' | translate}}" [(visible)]="displayDisableeModal"
    [modal]="true" [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    {{'Confirm_deactivate_offer' | translate}}
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayDisableeModal=false;disabledOffer()"
            label="{{'actions.unsubscribe' | translate}}" styleClass="p-button-danger"></p-button>
    </ng-template>
</p-dialog>

<!--  modal disable offer -->
<p-dialog position="bottom" header="{{'Confirm_reactivate_offer' | translate}}" [(visible)]="displayReactiveModal"
    [modal]="true" [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    {{'Confirm_reactivate_offer' | translate}}
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayReactiveModal=false;reactivateOffer()"
            label="{{'actions.reactivate' | translate}}" styleClass="p-button-warning"></p-button>
    </ng-template>
</p-dialog>